import { Injectable } from '@angular/core';

/**
 * Session-level master switch for the non-production tester tooling (auto-fill, Tester Approve,
 * auto-advance). Off by default; a System Administrator flips it on via the "Tester Tools" toggle
 * rendered on the SCF form (see scf-v2-main).
 *
 * This is an extra OPT-IN layer that sits on top of the non-prod + SA gates — it never, on its own,
 * exposes anything in production. As a root singleton the state is shared across every section of
 * the form and resets to off on a full page reload.
 */
@Injectable({ providedIn: 'root' })
export class TesterToolsService {
  /** Whether the tester tooling is currently switched on for this session. */
  enabled = false;
}
